'use client';

import dynamic from 'next/dynamic';
import { BASE_FILE_URL, COLORS } from '@/common/constants';
import { twMerge } from 'tailwind-merge';
import isEmpty from 'lodash/isEmpty';

// Dynamically import heavy PDF libraries only when needed
const Worker = dynamic(() => import('@react-pdf-viewer/core').then((mod) => mod.Worker), { ssr: false });

const Viewer = dynamic(() => import('@react-pdf-viewer/core').then((mod) => mod.Viewer), { ssr: false });

const defaultLayoutPlugin = dynamic(() => import('@react-pdf-viewer/default-layout').then((mod) => mod.defaultLayoutPlugin), { ssr: false });

// Load styles only when PDF page is rendered
import('@react-pdf-viewer/core/lib/styles/index.css');
import('@react-pdf-viewer/default-layout/lib/styles/index.css');

const PdfView = (props) => {
  const { posts } = props;
  const url = posts?.fileDocuments?.[0] || '';
  const title = posts?.title || '';

  if (isEmpty(url) || url === 'undefined') {
    return <h1 className={twMerge('text-2xl font-bold mb-5 ', COLORS.primary)}>{title || 'No PDF available'}</h1>;
  }

  // Render PDF viewer only when URL exists
  return (
    <>
      <h1 className={twMerge('text-2xl font-bold mb-5 ', COLORS.primary)}>{title}</h1>
      <div style={{ height: '1500px' }}>
        <PdfViewerComponent url={url} />
      </div>
    </>
  );
};

// Separate component for actual PDF rendering
function PdfViewerComponent({ url }) {
  try {
    const defaultLayoutPluginInstance = defaultLayoutPlugin?.();

    return (
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
        <Viewer fileUrl={`${BASE_FILE_URL}/${url}`} plugins={defaultLayoutPluginInstance ? [defaultLayoutPluginInstance] : []} />
      </Worker>
    );
  } catch {
    return <div>Error loading PDF viewer</div>;
  }
}

export default PdfView;
